// extracted by mini-css-extract-plugin
module.exports = {"absence_type":"AbsenceType_absence_type__2TCsh","modal_heading":"AbsenceType_modal_heading__18SRX","type":"AbsenceType_type__1yhoa"};